"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmaCosmWasmCw721Service = exports.Cw721MsgData = void 0;
var FirmaUtil_1 = require("./FirmaUtil");
var CosmWasmTxClient_1 = require("./firmachain/cosmwasm/CosmWasmTxClient");
// staic util
var noFunds = [];
var Cw721MsgData = /** @class */ (function () {
    function Cw721MsgData() {
    }
    Cw721MsgData.getMsgDataMint = function (owner, token_id, token_uri) {
        return JSON.stringify({
            "mint": {
                token_id: token_id,
                owner: owner,
                extension: {},
                token_uri: token_uri
            }
        });
    };
    Cw721MsgData.getMsgDataBurn = function (token_id) {
        return JSON.stringify({
            "burn": {
                token_id: token_id
            }
        });
    };
    Cw721MsgData.getMsgDataTransfer = function (recipient, token_id) {
        return JSON.stringify({
            "transfer_nft": {
                recipient: recipient,
                token_id: token_id
            }
        });
    };
    Cw721MsgData.getMsgDataApprove = function (spender, token_id, expires) {
        return JSON.stringify({
            "approve": {
                spender: spender,
                token_id: token_id,
                expires: expires
            }
        });
    };
    Cw721MsgData.getMsgDataRevoke = function (spender, token_id) {
        return JSON.stringify({
            "revoke": {
                spender: spender,
                token_id: token_id
            }
        });
    };
    Cw721MsgData.getMsgDataApproveAll = function (operator, expires) {
        return JSON.stringify({
            "approve_all": {
                operator: operator,
                expires: expires
            }
        });
    };
    Cw721MsgData.getMsgDataRevokeAll = function (operator) {
        return JSON.stringify({
            "revoke_all": {
                operator: operator
            }
        });
    };
    Cw721MsgData.getMsgDataSendNft = function (contract, token_id, msg) {
        return JSON.stringify({
            "send_nft": {
                contract: contract,
                token_id: token_id,
                msg: btoa(JSON.stringify(msg))
            }
        });
    };
    Cw721MsgData.getMsgUpdateOwnerShipTransfer = function (new_owner, expiry) {
        return JSON.stringify({
            "update_ownership": {
                "transfer_ownership": {
                    new_owner: new_owner,
                    expiry: expiry
                }
            }
        });
    };
    Cw721MsgData.getMsgUpdateOwnerShipAccept = function () {
        return JSON.stringify({
            "update_ownership": "accept_ownership"
        });
    };
    Cw721MsgData.getMsgUpdateOwnerShipRenounce = function () {
        return JSON.stringify({
            "update_ownership": "renounce_ownership"
        });
    };
    return Cw721MsgData;
}());
exports.Cw721MsgData = Cw721MsgData;
var FirmaCosmWasmCw721Service = /** @class */ (function () {
    function FirmaCosmWasmCw721Service(config, cosmwasmService) {
        this.config = config;
        this.cosmwasmService = cosmwasmService;
    }
    // tx
    FirmaCosmWasmCw721Service.prototype.mint = function (wallet, contractAddress, owner, token_id, token_uri, txMisc) {
        if (token_uri === void 0) { token_uri = ""; }
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataMint(owner, token_id, token_uri);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getUnsignedTxMint = function (wallet, contractAddress, owner, token_id, token_uri) {
        if (token_uri === void 0) { token_uri = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataMint(owner, token_id, token_uri);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.burn = function (wallet, contractAddress, token_id, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataBurn(token_id);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getUnsignedTxBurn = function (wallet, contractAddress, token_id) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataBurn(token_id);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.transfer = function (wallet, contractAddress, recipient, token_id, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataTransfer(recipient, token_id);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getUnsignedTxTransfer = function (wallet, contractAddress, recipient, token_id) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataTransfer(recipient, token_id);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.approve = function (wallet, contractAddress, spender, token_id, expires, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataApprove(spender, token_id, expires);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getUnsignedTxApprove = function (wallet, contractAddress, spender, token_id, expires) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataApprove(spender, token_id, expires);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.revoke = function (wallet, contractAddress, spender, token_id, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataRevoke(spender, token_id);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getUnsignedTxRevoke = function (wallet, contractAddress, spender, token_id) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataRevoke(spender, token_id);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.approveAll = function (wallet, contractAddress, operator, expires, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataApproveAll(operator, expires);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getUnsignedTxApproveAll = function (wallet, contractAddress, operator, expires) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataApproveAll(operator, expires);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.revokeAll = function (wallet, contractAddress, operator, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataRevokeAll(operator);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getUnsignedTxRevokeAll = function (wallet, contractAddress, operator) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataRevokeAll(operator);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.sendNft = function (wallet, contractAddress, targetContractAddress, token_id, msg, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataSendNft(targetContractAddress, token_id, msg);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getUnsignedTxSendNft = function (wallet, contractAddress, targetContractAddress, token_id, msg) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataSendNft(targetContractAddress, token_id, msg);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.updateOwnerShipTransfer = function (wallet, contractAddress, new_owner, expiry, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgUpdateOwnerShipTransfer(new_owner, expiry);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getUnsignedTxUpdateOwnerShipTransfer = function (wallet, contractAddress, new_owner, expiry) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgUpdateOwnerShipTransfer(new_owner, expiry);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.updateOwnerShipAccept = function (wallet, contractAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgUpdateOwnerShipAccept();
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getUnsignedTxUpdateOwnerShipAccept = function (wallet, contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgUpdateOwnerShipAccept();
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.updateOwnerShipRenounce = function (wallet, contractAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgUpdateOwnerShipRenounce();
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getUnsignedTxUpdateOwnerShipRenounce = function (wallet, contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgUpdateOwnerShipRenounce();
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.signAndBroadcast = function (wallet, msgList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        txClient = new CosmWasmTxClient_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.signAndBroadcast(msgList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getGasEstimationSignAndBroadcast = function (wallet, msgList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, txRaw, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        txClient = new CosmWasmTxClient_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign(msgList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_2 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // gas
    FirmaCosmWasmCw721Service.prototype.getGasEstimationMint = function (wallet, contractAddress, owner, token_id, token_uri) {
        if (token_uri === void 0) { token_uri = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataMint(owner, token_id, token_uri);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getGasEstimationBurn = function (wallet, contractAddress, token_id) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataBurn(token_id);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getGasEstimationTransfer = function (wallet, contractAddress, recipient, token_id) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataTransfer(recipient, token_id);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getGasEstimationApprove = function (wallet, contractAddress, spender, token_id, expires) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataApprove(spender, token_id, expires);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getGasEstimationRevoke = function (wallet, contractAddress, spender, token_id) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataRevoke(spender, token_id);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getGasEstimationApproveAll = function (wallet, contractAddress, operator, expires) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataApproveAll(operator, expires);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getGasEstimationRevokeAll = function (wallet, contractAddress, operator) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataRevokeAll(operator);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getGasEstimationSendNft = function (wallet, contractAddress, targetContractAddress, token_id, msg) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgDataSendNft(targetContractAddress, token_id, msg);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getGasEstimationUpdateOwnerShipTransfer = function (wallet, contractAddress, new_owner, expiry) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgUpdateOwnerShipTransfer(new_owner, expiry);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getGasEstimationUpdateOwnerShipAccept = function (wallet, contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgUpdateOwnerShipAccept();
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getGasEstimationUpdateOwnerShipRenounce = function (wallet, contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = Cw721MsgData.getMsgUpdateOwnerShipRenounce();
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // query
    FirmaCosmWasmCw721Service.prototype.getOwnerFromNftID = function (contractAddress, tokenId) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"owner_of\": { \"token_id\": \"" + tokenId + "\" }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.owner];
                    case 2:
                        error_3 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getApproval = function (contractAddress, tokenId, spender, isIncludeExpired) {
        if (isIncludeExpired === void 0) { isIncludeExpired = false; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"approval\": { \"token_id\": \"" + tokenId + "\", \"spender\" : \"" + spender + "\", \"include_expired\" : " + isIncludeExpired + " }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.approval];
                    case 2:
                        error_4 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getApprovals = function (contractAddress, tokenId, isIncludeExpired) {
        if (isIncludeExpired === void 0) { isIncludeExpired = false; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"approvals\": { \"token_id\": \"" + tokenId + "\", \"include_expired\" : " + isIncludeExpired + " }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.approvals];
                    case 2:
                        error_5 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getAllOperators = function (contractAddress, owner, isIncludeExpired, limit, start_after) {
        if (isIncludeExpired === void 0) { isIncludeExpired = false; }
        if (limit === void 0) { limit = 10; }
        if (start_after === void 0) { start_after = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"all_operators\": { \"owner\": \"" + owner + "\", \"include_expired\" : " + isIncludeExpired + ", \"limit\": " + limit + ", \"start_after\": \"" + start_after + "\" }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.operators];
                    case 2:
                        error_6 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_6);
                        throw error_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getOperator = function (contractAddress, owner, operator, isIncludeExpired) {
        if (isIncludeExpired === void 0) { isIncludeExpired = false; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"operator\": { \"owner\": \"" + owner + "\", \"operator\": \"" + operator + "\" ,\"include_expired\" : " + isIncludeExpired + " }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.approval];
                    case 2:
                        error_7 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_7);
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getTotalNfts = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"num_tokens\": { }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.count];
                    case 2:
                        error_8 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_8);
                        throw error_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getContractInfo = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"contract_info\": { }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data];
                    case 2:
                        error_9 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_9);
                        throw error_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getNftTokenUri = function (contractAddress, tokenId) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"nft_info\": { \"token_id\": \"" + tokenId + "\" }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.token_uri];
                    case 2:
                        error_10 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_10);
                        throw error_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getNftData = function (contractAddress, tokenId) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"all_nft_info\": { \"token_id\": \"" + tokenId + "\" }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data];
                    case 2:
                        error_11 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_11);
                        throw error_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getNFTIdListOfOwner = function (contractAddress, owner, limit, start_after) {
        if (limit === void 0) { limit = 10; }
        if (start_after === void 0) { start_after = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"tokens\": { \"owner\": \"" + owner + "\", \"limit\": " + limit + ", \"start_after\": \"" + start_after + "\" }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.tokens];
                    case 2:
                        error_12 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_12);
                        throw error_12;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getAllNftIdList = function (contractAddress, limit, start_after) {
        if (limit === void 0) { limit = 10; }
        if (start_after === void 0) { start_after = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"all_tokens\": { \"limit\": " + limit + ", \"start_after\": \"" + start_after + "\" }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.tokens];
                    case 2:
                        error_13 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_13);
                        throw error_13;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getMinter = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"minter\": { }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data.minter];
                    case 2:
                        error_14 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_14);
                        throw error_14;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getExtension = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"extension\": { \"msg\": {} }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data];
                    case 2:
                        error_15 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_15);
                        throw error_15;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCw721Service.prototype.getOwnerShip = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result, data, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = "{\"ownership\": { }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        data = JSON.parse(result);
                        return [2 /*return*/, data];
                    case 2:
                        error_16 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_16);
                        throw error_16;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return FirmaCosmWasmCw721Service;
}());
exports.FirmaCosmWasmCw721Service = FirmaCosmWasmCw721Service;
